import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Initial ByteBite ADMIN area.
 *
 * Lives inside the Dashboard, not a separate app. A staff session is required
 * (same gate as the rest of the SPA). There is no extra role matrix in this
 * slice: both RESTAURANT and ADMIN may open `/admin`.
 */
export function AdminPage() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Admin</h1>
        <p className="text-muted-foreground text-sm">
          Internal ByteBite admin area (placeholder). A staff session is required;
          there is no extra role check yet.
        </p>
      </div>
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Admin area</CardTitle>
          <CardDescription>
            Lives inside the Dashboard. No separate apps/admin application.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-muted-foreground text-sm">
          Admin tooling is implemented during feature work.
        </CardContent>
      </Card>
    </div>
  );
}
